export { MasterDetailModule } from './masterDetailModule.mjs';
